import React, { Component } from 'react';
import CurrencyFormat from 'react-currency-format';
import InputElement from 'react-input-mask';
import { currencyToFloat, phoneValidation, checkCPF, convertToDate, validateCurrentDate, checkCharsMessage, cellPhoneValidation } from 'utils/utils';
import './Input.scss'
import { floatToCurrency } from '../../utils/utils';
export default class Input extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value,
			inError: false,
			errorMessage: undefined,
			validation: {
        rules: {
          email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          surname: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]{2,}([ ]{0,}[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]{1,1})+$/,
          lastName: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]{2,}( {1,1}[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð]{1,})+$/,
          date: /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/,
          money: /^(?!0\.00)[1-9]\d{0,2}(,\d{3})*(\.\d\d)?$/,
        },
				messages: {
					email: {
						regex: 'E-mail é inválido',
						required: 'O campo e-mail deve ser preenchido e deve ter no mínimo {#chars} caracteres.',
					},
					surname: {
						regex: 'Nome inválido',
						required: 'O campo nome deve ser preenchido e deve ter no mínimo {#chars} caracteres.',
					},
          lastName: {
						regex: 'Nome deve conter sobrenome',
						required: 'O campo nome deve ser preenchido e deve ter no mínimo {#chars} caracteres.',
					},
					numberPhone: {
						regex: 'Telefone',
						required: 'O campo Telefone deve ser preenchido e deve ter no mínimo {#chars} caracteres.',
					},
					numberCellPhone: {
						regex: 'Celular',
						required: 'O campo Telefone deve ser preenchido e deve ter no mínimo {#chars} caracteres.',
					},
					message: {
						regex: 'Mensagem',
						required: 'O campo Mensagem deve ser preenchido e deve ter no mínimo {#chars} caracteres.',
					},
					intake: {
						regex: 'Entrada',
						required: 'O campo Entrada deve ser preenchido e deve ter no mínimo {#chars} caracteres.',
					},
				},
			},
		}
		this.validateField = this.validateField.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.forceValidate !== this.props.forceValidate && this.props.forceValidate) {
			this.validateField();
		}
	}

  validateFullName(str) {
    if (str[0] === '') return false;
    return (
      /^[A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*$/.test(str) &&
      /[A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff]\s[A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff]/.test(str) &&
      /\s/.test(str) &&
      !/\s\s[A-Za-z]/.test(str)
    );
  };

	showErrorMessage = () => {
		let _errorMessage = undefined;
		if (this.props.errorMessage) {
			_errorMessage = this.props.errorMessage;
		} else {
			_errorMessage = 'Campo inválido';
		}
		this.setState({ errorMessage: _errorMessage })
	}

	validateRequiredField = () => {
		let _errorRequired = false;
		if (typeof this.props.required === 'object') {
			let _minChars = (this.props.required.minChars) ? this.props.required.minChars : false;
			let _maxChars = (this.props.required.maxChars) ? this.props.required.maxChars : false;

			if ((_minChars && this.state.value && this.state.value.length < _minChars) || _maxChars && this.state.value && this.state.value.length > _maxChars) {
				_errorRequired = true;
			}

		} else {
			if (this.state.value || this.state.value == 0) {
				_errorRequired = false;
			} else {
				_errorRequired = true;
			}
		}
		return _errorRequired;
	}

	validateField = () => {
		let _inError = this.validateRequiredField();
		if (!_inError && this.props.regex) {
			if (this.props.regex == "numberPhone") {
				_inError = !phoneValidation(this.state.value);
			} else if (this.props.regex === "numberCellPhone") {
				_inError = !cellPhoneValidation(this.state.value);
			} else if (this.props.regex === "cpf") {
				_inError = (!checkCPF(this.state.value));
			} else if (this.props.regex === 'money' && this.props.minInputValue >= 0) {
				_inError = typeof this.props.value === 'string' ? this.props.minInputValue > currencyToFloat(this.props.value) : this.props.minInputValue > floatToCurrency(this.props.value);
			} else if (this.props.regex === 'money' && this.props.maxInputValue >= 0) {
				_inError = typeof this.props.value === 'string' ? this.props.maxInputValue < currencyToFloat(this.props.value) : this.props.maxInputValue < floatToCurrency(this.props.value);
			} else if (this.props.regex === "messageReport") {
        _inError = checkCharsMessage(this.state.value, this.props.required && this.props.required.minChars ? this.props.required.minChars : 10)
      } else if (this.props.regex === 'fullname') {
        _inError = !this.state.validation.rules.surname.test(this.state.value.trim()) || !this.validateFullName(this.state.value)
      } else if (this.props.regex === 'birthday') {
        _inError = !this.state.validation.rules.surname.test(this.state.value.trim()) || !this.validateFullName(this.state.value)
      } else if (this.state.validation.rules[this.props.regex]) {
				this.props.customErrorMessage && this.props.customErrorMessage();
				_inError = !this.state.validation.rules[this.props.regex].test(this.state.value.trim());

				let _arrayDate = this.state.value.split('/')
				let _dateFormat = convertToDate(_arrayDate[0], _arrayDate[1], _arrayDate[2])
				let currentDate = new Date().toJSON().slice(0,10)+' 00:00:00';
				let yearInMillisecond = 31557600000;
				let age = ~~((Date.now(currentDate) - _dateFormat) / (yearInMillisecond));
				let validationDayAndMonth = _arrayDate[0] > 31 || _arrayDate[1] > 12;

				if (_inError && this.props.regex == "date" && validationDayAndMonth) {
					this.props.customErrorMessage(age, validationDayAndMonth);
				}

				if (!_inError && this.props.regex == "date") {
					_inError = !validateCurrentDate(_dateFormat)
					if (!_inError && this.props.name === "birthday") {
						if(age < 18 || age > 99) {
							_inError = true;
							this.props.customErrorMessage(age, validationDayAndMonth);
						}
					}
				}
			} else {
				_inError = !this.props.regex.test(this.state.value.trim());
			}
		}

		this.props.formValidation && this.props.formValidation(_inError, this.props.name)
		this.setState({ inError: _inError }, () => this.showErrorMessage());
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			this.setState({ value: (this.props.type === 'email') ? nextProps.value.toLowerCase() : nextProps.value });
		}
		if (nextProps.showErrors !== this.props.showErrors) {
			this.validateField();
		}
	}

  componentDidMount() {
    if(this.props.showErrors && this.props.value && this.props.startErrorValidation) this.validateField();
  }

	renderToggle() {
		return (
			<div
        data-qa={this.props.dataQA || undefined}
				className={'Form__field Form__field__wide' + (this.props.className ? ' ' + this.props.className : '')}
				data-name={this.props.name}
				data-checked={(this.props.checked) ? true : false}
				onClick={(e) => this.props.onChange(e)}
			>
				{this.props.label}
				<span className={"Form__toggle" + (this.props.checked ? ' Form__toggle--checked' : '')}>&nbsp;</span>
			</div>)
	}

	renderInputCheckbox = () => {
		return (
			<div className={'Form__field' + (this.props.className ? ' ' + this.props.className : '')} data-name={this.props.name} data-checked={(this.props.checked) ? true : false} onClick={(e) => this.props.onChange(e)}>
				<label className="Form__label">
					<span className="Form__checkbox">&nbsp;</span>
					{this.props.label}
				</label>
			</div>
		)
	}

	renderTextArea = () => {
		return (
			<div className={'Form__field' + (this.props.className ? ' ' + this.props.className : '') + (this.state.inError && !this.props.dontShowError ? ' Form__field--error' : '')}>
				<textarea
					className={(this.props.value) ? 'Form__field__filled' : ''}
					name={this.props.name} onChange={(e) => this.props.onChange(e)}
					onBlur={(e) => this.props.onBlur && this.props.onBlur(e)}
					value={this.state.value}
					placeholder={this.props.placeholder}
					onKeyUp={this.validateField}
					autoComplete="nope"
					maxLength="1000" />
				<label className="Form__field__label">{this.props.label}</label>
				{this.state.inError && !this.props.dontShowError ? <span className="Form__field__error"> {this.state.errorMessage} </span> : ''}
			</div>
		)
	}

	renderInputText = () => {
		let CustomInput = 'input';
		(this.props.format || this.props.mask || this.props.regex == 'numberPhone' || this.props.regex === 'numberCellPhone' ) && (CustomInput = InputElement);
		(this.props.regex === 'money') && (CustomInput = CurrencyFormat);
		let extraProps = {}
		if (this.props.regex === 'money') {
			extraProps = {
				thousandSeparator: ".",
				thousandSpacing: "3",
				decimalSeparator: ",",
				decimalScale: this.props.decimalScale || 0,
				fixedDecimalScale: this.props.decimalScale,
				maskChar: this.props.maskChar ? this.props.maskChar : '',
				prefix:"R$ "
			}
		}
		if (CustomInput == InputElement) {
			extraProps = {
				maskChar: this.props.maskChar ? this.props.maskChar : ''
			}
		}
		if (this.props.regex == 'numberPhone' ||  this.props.regex === 'numberCellPhone') {
			extraProps.mask = (this.props.value && this.props.value.length > 14 ? "(99) 99999-9999" : "(99) 9999-99999")
			extraProps.maskChar = ''
		}
		return (
			<div className={'Form__field' + (this.props.className ? ' ' + this.props.className : '') + (this.state.inError && !this.props.dontShowError ? ' Form__field--error' : '')}>
				<CustomInput
					mask={(this.props.mask) ? this.props.mask : ''}
					type={(this.props.type) ? this.props.type : 'text'}
					name={this.props.name}
					className={((this.props.value) ? 'Form__field__filled' : '') + (this.props.dontShowError ? ' Form__field__noerror' : '')}
					value={this.state.value}
					onChange={ e => this.props.onChange(e) }
					onFocus={ e => (this.props.onFocus) ? this.props.onFocus(e) : '' }
					onBlur={!this.props.onBlur ? (e) => { this.props.onChange(e); this.validateField(); } : this.props.onBlur}
					onKeyUp={this.validateField}
					tabIndex={this.props.tabIndex}
					autoComplete="nope"
					maxLength={this.props.maxLength ? this.props.maxLength : ''}
          data-qa={this.props.dataQA ? this.props.dataQA : null }
          data-testid={this.props.dataTestId}
          disabled={this.props.disabledInput}
					{...extraProps}
				/>
				<label className="Form__field__label">{this.props.label}</label>
				{this.state.inError && !this.props.dontShowError ? <span className="Form__field__error"> {this.state.errorMessage} </span> : ''}
			</div>
		)
	}
	render() {
		let _result;
		if (this.props.type == 'toggle') {
			_result = this.renderToggle();
		}
		else if (this.props.type == 'checkbox') {
			_result = this.renderInputCheckbox();
		}
		else if (this.props.name == 'message') {
			_result = this.renderTextArea();
		}
		else {
			_result = this.renderInputText();
		}
		return (_result)
	}
}
